import { Status } from "./Status";
import Processors from "./Processors";

export default class Job {
  private dueDate: string;
  private dueTime: string;
  private requestId: string;
  private jobType: string;
  private jobId: string;
  private status: Status;
  private createdDate: string;
  private createdBy: string;
  private updatedDate: string;
  private updatedBy: string;
  private source: Object;
  private processor: Processors;
  private delivery: Array<any>;
  private auditTrail: Array<any>;
  private assignedTo: Object;
  private needsSourceOverride: boolean;
  private qcRequired: boolean;

  constructor(
    dueDate: string,
    dueTime: string,
    requestId: string,
    jobTypeId: string,
    jobId: string,
    status: Status,
    createdDate: string = null,
    createdBy: string = null,
    updatedDate: string = null,
    updatedBy: string = null,
    source: Object,
    processor: Processors,
    delivery: Array<any>,
    auditTrail: Array<any>,
    assignedTo: Object,
    needsSourceOverride: boolean,
    qcRequired: boolean
  ) {
    this.dueDate = dueDate;
    this.dueTime = dueTime;
    this.requestId = requestId;
    this.jobType = jobTypeId;
    this.jobId = jobId;
    this.status = status;
    this.createdDate = createdDate;
    this.updatedBy = updatedBy;
    this.createdBy = createdBy;
    this.updatedDate = updatedDate;
    this.source = source;
    this.processor = processor;
    this.delivery = delivery;
    this.auditTrail = auditTrail;
    this.assignedTo = assignedTo;
    this.needsSourceOverride = needsSourceOverride;
    this.qcRequired = qcRequired;
  }
}
